'use strict'

import React, { useEffect, useState } from 'react'
import { decode } from 'html-entities'

function TradeInProduct (props) {
  // отфильтрованный список групп по наличию товаров в группе
  const [groups, setGroups] = useState(props.groups.filter(group => group.hasOwnProperty('products') && Array.isArray(group.products) && group.products.length))
  // текущая выбранная группа с товарами и свойствами которой работаем
  const [activeGroup, setActiveGroup] = useState(null)
  // активное свойство, используется для открытия выпадающего списка
  const [activePropId, setActivePropId] = useState(null)
  // список отфильтрованных товаров
  const [filteredProducts, setFilteredProducts] = useState([])
  // отфильтрованный товар на основании выбора значений свойств
  const [checkedProduct, setCheckedProduct] = useState(null)
  // список свойств и отфильтрованных значений (которые учавствуют в формировании товара)
  const [filteredPropList, setFilteredPropList] = useState([])
  // список свойств для которых не найдено значений у товаров
  const [emptyPropIds, setEmptyPropIds] = useState([])

  /**
   * установка активной группы по умолчанию
   */
  useEffect(() => {
    if (!groups.length || activeGroup !== null) return
    setActiveGroup(groups[0])
  }, [groups])

  /**
   * при изменении кол-ва выбранных свойств - сравнивается кол-во выбранных свойств и полного набора
   * если не сответствует и есть выбранный товар - сбрасываем выбранный товар
   */
  useEffect(() => {
    if (activeGroup === null) return

    let participationg_props_length = activeGroup.property_ids.length - Object.values(emptyPropIds).length
    let checked_props_length = Object.keys(props.checkedPropValues).length

    if (checkedProduct !== null && checked_props_length !== participationg_props_length) {
      setCheckedProduct(null)
    }
  }, [props.checkedPropValues])

  /**
   * при выборе значений свойств / отфильтровываем список товаров
   */
  useEffect(() => {
    if (activeGroup === null) return
    //console.log('при выборе значений свойств / отфильтровываем список товаров')
    // список товаров которые актуальны на текущий момент, по всем выбранным свойствам
    let filtered_products = getFilteredProducts(activeGroup.products, props.checkedPropValues)
    //console.info(activeGroup, props.checkedPropValues, filtered_products)
    setFilteredProducts(filtered_products)
  }, [props.checkedPropValues])

  /**
   * при смене группы формируем список свойств со значениями с которыми будем работать
   */
  useEffect(() => {
    if (activeGroup === null) return

    //console.log('формирование списка свойств со значениями')

    let prop_ids = [...activeGroup.property_ids]
    let checked_prop_values = {}
    let products = [...activeGroup.products]

    Object.assign(checked_prop_values, props.checkedPropValues)

    let tmp_props = propFilterLogic(prop_ids, products, checked_prop_values)

    //console.info(tmp_props)
    // устанавливаем список свойств для группы товаров
    setFilteredPropList(tmp_props)
  }, [activeGroup, props.checkedPropValues])

  /**
   * при смене группы устанавливаем отфильтрованный список товаров в исходное положение
   */
  useEffect(() => {
    if (activeGroup === null) return
    //console.log('при смене группы устанавливаем отфильтрованный список товаров в исходное положение')

    setFilteredProducts(activeGroup.products)
  }, [activeGroup])

  /**
   * при смене активной группы сбрасываем выбранный товар
   */
  useEffect(() => {
    if (activeGroup === null || checkedProduct === null) return
    setCheckedProduct(null)
  }, [activeGroup])

  /**
   * при смене активной группы расчитываем дипазон цен для товаров на обмен
   */
  useEffect(() => {
    if (props.type !== 'exchange' || activeGroup === null) return

    let prices = []

    activeGroup.products.forEach(product => {
      prices.push(Number(Math.round(product.price)))
    })

    //console.info(prices)

    props.setExchangePriceRange({ min: Math.min(...prices), max: Math.max(...prices), name: activeGroup.name })
  }, [activeGroup])

  /**
   * логика работает при изменении кол-ва отфильтрованных товаров
   */
  useEffect(() => {
    // пропускаем если / логика или
    // - группа не установлена пропускаем обработку
    // - есть выбранный товар
    // - выбранны не все значения свойств

    if (activeGroup === null) return

    let participationg_props_length = activeGroup.property_ids.length - Object.values(emptyPropIds).length
    let checked_props_length = Object.keys(props.checkedPropValues).length

    if (checked_props_length !== participationg_props_length) return

    //console.info('filteredProducts.length', filteredProducts.length)

    // при изменении кол-ва отфильтрованных товаров
    if (filteredProducts.length === 1) {

      // если остался 1 товар сохраняем его
      setCheckedProduct(filteredProducts[0])

    } else if (filteredProducts.length > 1) {

      // производим поиск приоритетного товара
      let priority_product = findPriorityProduct(filteredProducts)

      //console.info('priority_product', priority_product)

      // если найден приоритетный - сохраняем его
      if (priority_product !== null) setCheckedProduct(priority_product)
      // приоритетный не найден - сохраняем первый из списка
      else setCheckedProduct(filteredProducts[0])

    }
  }, [filteredProducts])

  /**
   * при изменении отфильрованного товара отправляется родителю
   */
  useEffect(() => {
    //console.log('при изменении отфильрованного товара отправляется родителю')
    props.onProductChecked(checkedProduct, props.type)
  }, [checkedProduct])

  useEffect(() => {
    for(let items of filteredPropList) {
      if (items.values.length === 1 && !props.checkedPropValues.hasOwnProperty(items.property_id) && items.active) {
        onCheckValue(items.property_id, items.values[0].enum_id);
      }
    }

  }, [filteredPropList]);

  /**
   * при выборе значения свойства - сохраняем результат действия
   * @param property_id
   * @param value_enum_id
   */
  function onCheckValue (checked_property_id, checked_value_enum_id) {
    //console.info(property_id, value_enum_id)

    let props_ids = [...activeGroup.property_ids]

    // если меняется значение выбранного ранее свойства - сбрасываем все последующие
    if (props.checkedPropValues.hasOwnProperty(checked_property_id)) {
      let tmp_checked_props = {}

      for (let prop_id of props_ids) {
        // пропускаем пустые свойства
        if (emptyPropIds.includes(prop_id)) continue

        if (Number(prop_id) !== Number(checked_property_id))
          tmp_checked_props[prop_id] = props.checkedPropValues[prop_id]
        else {
          tmp_checked_props[prop_id] = checked_value_enum_id
          break
        }
      }

      //console.info(tmp_checked_props)

      props.setCheckedPropValues(tmp_checked_props)
    } else // иначе устанавливаем выбранное
      props.setCheckedPropValues({ ...props.checkedPropValues, [checked_property_id]: checked_value_enum_id })
  }

  /**
   * переключение состояния выпадающего списка значений свойства
   * @param prop_id
   */
  function onToggleDropdown (prop_id) {
    if (activePropId !== null && activePropId === prop_id) setActivePropId(null)
    else setActivePropId(prop_id)
  }

  /**
   * смена группы товаров / сбрасываем список выбранных значений
   * @param group_id
   */
  function onChangeGroup (group_id) {
    //console.info(group_id)
    let found_groups = groups.filter(group => {
      return Number(group.id) === Number(group_id)
    })
    //console.info(found_groups)
    setActiveGroup(found_groups[0])
    props.setCheckedPropValues({})
  }

  /**
   *
   * @param propIds список идентификаторов свойств группы
   * @param products общий список товаров
   * @param checkedPropValues набор выбранных значений свойств
   * @returns {*[]}
   */
  function propFilterLogic (propIds, products, checkedPropValues) {
    let tmp_props = []
    let empty_prop_ids = []

    for (let index in propIds) {
      let property_id = propIds[index]

      // формируем список выбранных свойств которые идет перед текущим
      let tmp_checked_prop_ids = propIds.slice(0, index)
      // формируем список выбранных значений свойств которые идет перед текущим
      let tmp_checked_prop_values = {}
      // наполняем выбранные значения свойств
      tmp_checked_prop_ids.forEach(tmp_prop_id => {
        if (checkedPropValues.hasOwnProperty(tmp_prop_id))
          tmp_checked_prop_values[tmp_prop_id] = checkedPropValues[tmp_prop_id]
      })

      //console.info(tmp_checked_prop_ids, tmp_checked_prop_values)

      // данные свойства, включая список значений
      let found_prop = getPropertyData(property_id)

      let tmp_products = getFilteredProducts(products, tmp_checked_prop_values)

      //console.info(products, tmp_products)

      // массив значений свойства для текущего набора товаров
      let tmp_values_enum_id = getPropertyValuesByProducts(property_id, tmp_products)

      //console.info(found_prop, tmp_values_enum_id)

      // наполнение данными о значениях свойства
      let filtered_values = []

      for (let enum_id in found_prop.values) {
        if (!found_prop.values.hasOwnProperty(enum_id) || !tmp_values_enum_id.includes(enum_id)) continue
        filtered_values.push(found_prop.values[enum_id])
      }

      //console.info(filtered_values)

      if (filtered_values.length) {
        let active_prop_ids = determineActiveProps(propIds, Object.keys(checkedPropValues), empty_prop_ids)

        tmp_props.push({
          active: active_prop_ids.includes(property_id),
          name: found_prop.name,
          property_id: found_prop.property_id,
          values: filtered_values
        })
      } else empty_prop_ids.push(property_id)
    }

    setEmptyPropIds(empty_prop_ids)

    return tmp_props
  }

  /**
   * Формируется список активных свойств
   *
   * @param groupPropIds список идентификаторов свойств в порядке настройки
   * @param checkedPropIds список идентификаторов выбранных свойств
   * @param emptyPropIds список идентификаторов свойств для которых нет значений
   * @returns {Number[]}
   */
  function determineActiveProps (groupPropIds, checkedPropIds, emptyPropIds = []) {
    let active_porp_ids = []

    // свойства добавляются пока они выбраны и одно не выбранное
    for (let tmp_prop_id of groupPropIds) {
      // пропускаем пустые свойства
      if (emptyPropIds.includes(tmp_prop_id)) continue
      // добавляем свойство как активное
      active_porp_ids.push(tmp_prop_id)
      if (!checkedPropIds.includes(tmp_prop_id)) break
    }

    return active_porp_ids
  }

  /**
   * Фильтрует список товаров по значениям свойств
   *
   * @param products
   * @param checked_props
   * @returns {*}
   */
  function getFilteredProducts (products, checked_props) {
    return products.filter(product => {
      let counter = 0

      for (let prop_id in checked_props) {
        if (product.prop_values.hasOwnProperty(prop_id) &&
          Number(checked_props[prop_id]) === Number(product.prop_values[prop_id]))
          counter++
      }

      return Object.keys(checked_props).length === counter
    })
  }

  /**
   * Поиск товара у которого свойтво "Версия" = "Global"
   * @param product_list
   * @returns {null}
   */
  function findPriorityProduct (product_list) {
    if (props.version === null || !props.version.hasOwnProperty('property_id') ||
      !props.version.hasOwnProperty('value_enum_id')) return null

    let priority_product = null

    for (let product of product_list) {
      if (!product.prop_values.hasOwnProperty(props.version.property_id) ||
        Number(product.prop_values[props.version.property_id]) !== Number(props.version.value_enum_id))
        continue

      priority_product = product
      break
    }

    return priority_product
  }

  /**
   * поиск общей информации свойства по его идентификатору
   * @param property_id
   * @returns {*}
   */
  function getPropertyData (property_id) {
    return props.property_data.find(property => Number(property_id) === Number(property.property_id))
  }

  /**
   * формирование идентификаторов значений свойства из списока товаров
   * @param property_id
   * @param product_list
   * @returns {Object[]}
   */
  function getPropertyValuesByProducts (property_id, product_list) {
    let values = []
    for (let product of product_list) {
      if (product.prop_values.hasOwnProperty(property_id) && !values.includes(product.prop_values[property_id]))
        values.push(product.prop_values[property_id])
    }
    return values
  }

  function getValueNameByEnumId (property_id, value_enum_id) {
    for (let property of props.property_data) {
      if (Number(property.property_id) !== Number(property_id)) continue
      if (property.values.hasOwnProperty(value_enum_id))
        return Number(property_id) === 355 ? decode(property.values[value_enum_id].name.replace(/ Б\/У/g, "")) : decode(property.values[value_enum_id].name)
    }
  }

  const renderValues = (propId, valueList) => {
    if (!Array.isArray(valueList) || !valueList.length) return []

    let value_list = []
    let local_values = [...valueList]

    local_values.sort((a, b) => (a.sort - b.sort))
      .map((value, index) => {
        value_list.push(
          <div key={`${propId}-${value.enum_id.toString()}`}
               className={props.checkedPropValues.hasOwnProperty(propId) &&
               Number(props.checkedPropValues[propId] === Number(value.enum_id)) ? 'checked' : ''}
               onClick={event => {
                 //console.log(propId)
                 onToggleDropdown(propId)
                 // игнорируем установку значения свойства если это значение уже выбрано
                 if (!props.checkedPropValues.hasOwnProperty(propId) ||
                   Number(props.checkedPropValues[propId]) !== Number(value.enum_id))
                   onCheckValue(propId, value.enum_id)
               }}>
            {Number(propId) === 355 ? decode(value.name.replace(/ Б\/У/g, "")) : decode(value.name)}
          </div>
        )
      })

    return value_list
  }

  const renderGroups = groups.length > 1 ? (
    <div key="group_selector" className={`select-input-holder ${activePropId === 'groups' ? 'show-select' : ''}`}>
      <input
        className={`select-input ${activeGroup ? 'has-value' : ''}`}
        onClick={() => onToggleDropdown('groups')}
        value={activeGroup ? activeGroup.name : ''}
        readOnly={true}
      />
      <div className="select-input-dropdown" style={{ width: '100%' }}>
        {groups.map(group => (
          <div
            key={`group-${group.id}`}
            className={Number(group.id) === Number(activeGroup?.id) ? 'checked' : ''}
            onClick={() => {
              onToggleDropdown('groups')
              onChangeGroup(Number(group.id))
            }}
          >
            {group.name}
          </div>
        ))}
      </div>
      <label className="label-select-input">{props.getMessage('tradeInCategory')}</label>
      <div className="selectbox__arrow"></div>
    </div>
  ) : null

  const renderProps = filteredPropList.map(property => {
    let class_name = `select-input-holder`

    // выбор значения, показ выпадающего списка
    if (activePropId && activePropId === Number(property.property_id)) class_name = class_name.concat(' ', 'show-select')

    // свойство активно, доступно для выбора
    if (!property.active) class_name = class_name.concat(' ', 'disabled')

    return <div key={`prop_${property.property_id}`} className={class_name}>
      <input
        className={`select-input ${props.checkedPropValues.hasOwnProperty(property.property_id) ? 'has-value' : ''}`}
        onClick={event => {
          if (!property.active) return
          //console.log(property.property_id)
          onToggleDropdown(Number(property.property_id))
        }}
        value={props.checkedPropValues.hasOwnProperty(property.property_id) ?
          getValueNameByEnumId(property.property_id, props.checkedPropValues[property.property_id]) :
          ''}
        readOnly={true}/>
      <div className="select-input-dropdown" style={{ width: '100%' }}>
        {
          property.active ?
            renderValues(property.property_id, property.values) :
            <></>
        }
      </div>
      <label className="label-select-input">{decode(property.name)}</label>
      <div className="selectbox__arrow"></div>
    </div>
  })

  /**
   * при изменении отфильтрованного списка товаров формируем список свойств и значений на основании значений товаров группы
   */
  /*useEffect(() => {
    if (activeGroup === null) return

    //console.log('при изменении отфильтрованного списка товаров формируем список свойств и значений на основании значений товаров группы')
    //console.info(activeGroup)

    // формируем список свойств и значений
    let tmp_props = []

    activeGroup.property_ids.forEach((property_id, index) => {
      // данные свойства, включая список значений
      let found_prop = getPropertyData(property_id)
      // если свойство выбранно используем все товары для поиска
      // иначе отфильтрованный список твоаров
      let tmp_values_enum_id = []

      if (index === 0) // не фильтруется первое свойство, всегда полный набор значений
        tmp_values_enum_id = getPropertyValuesByProducts(property_id, activeGroup.products)
      else if (lastStepProducts.length && lastCheckedPropId > 0 && Number(property_id) === Number(lastCheckedPropId))
        tmp_values_enum_id = getPropertyValuesByProducts(property_id, lastStepProducts)
      else
        tmp_values_enum_id = getPropertyValuesByProducts(property_id, filteredProducts)

      //console.info(found_prop, tmp_values_enum_id)

      let filtered_values = []

      for (let enum_id in found_prop.values) {
        if (!found_prop.values.hasOwnProperty(enum_id) || !tmp_values_enum_id.includes(enum_id)) continue
        filtered_values.push(found_prop.values[enum_id])
      }

      //console.info(filtered_values)

      if (filtered_values.length) {
        tmp_props.push({
          name: found_prop.name,
          property_id: found_prop.property_id,
          values: filtered_values
        })
      }
    })

    //console.info(tmp_props)
    // устанавливаем список свойств для группы товаров
    setFilteredPropList(tmp_props)
  }, [filteredProducts])*/

  return (
    <>
      <div className="change-input-fields">
        {renderGroups}
        {
          activeGroup && filteredPropList.length ?
            renderProps :
            <></>
        }
      </div>
    </>
  )
}

export default TradeInProduct